'use strict';

angular.module('mean.admin-panel').controller('BuilderAdminController', ['$scope', 'Users', 'Global', 'MeanUser', '$filter', 'toaster', '$q', 'AdminPanel', function($scope, Users, Global, MeanUser, $filter, toaster, $q, AdminPanel) {
    $scope.global = Global;
    $scope.package = {
      name: 'admin-panel'
    };
    $scope.user = MeanUser.user;

    for(var i=0; i<$scope.user.roles.length; i++) {
        if ($scope.user.roles[i] === 'builder_admin') {
            $scope.builder_admin = true;
        }
    }

    if(!$scope.builder_admin) {
        toaster.pop('error', 'Admin Panel', 'You do not have the proper permissions for this page.');
        return;
    }
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/buiderAdminPanel.js